import { IoDocumentAttach } from "react-icons/io5";
import {
  MdCancel,
  MdOutlineFilePresent,
  MdOutlineMailOutline,
  MdUpdate,
} from "react-icons/md";
import {
  RiArrowLeftFill,
  RiArrowRightFill,
  RiBallPenFill,
  RiMessage2Fill,
} from "react-icons/ri";
import { RxComponentPlaceholder } from "react-icons/rx";

export const tooltipStyle = {
  error: {
    tooltip: {
      sx: {
        background: "red",
        color: "white",
        fontSize: 12,
        padding: 1,
      },
    },
    arrow: { sx: { color: "red" } },
  },
};

export enum HistoricoType {
  Email = 1,
  Chat = 2,
  Avancou = 3,
  Voltou = 4,
  Atualizou = 5,
  UploadDocumento = 6,
  ContraPropostaAjuste = 7,
  Reprovado = 8,
  PropostaCancelada = 9,
  BaixaCheckListCredito = 10,
  AprovadoConferenciaCheckList = 11,
  ComprovantePagamentoAto = 12,
  PropostaAssinada = 13,
  BaixaCheckListSuporteFinanceiro = 14,
  CompartilharOportunidade = 15,
  Compartilhado = 15,
  CapturaResponsavelProposta = 16,
  Ajustes = 20,
}

export const bg_ = (type: HistoricoType) => {
  switch (type) {
    case HistoricoType.Reprovado:
    case HistoricoType.PropostaCancelada:
      return "#F4363633";
    case HistoricoType.ContraPropostaAjuste:
      return "#ED6C0233";
    case HistoricoType.Atualizou:
    case HistoricoType.CompartilharOportunidade:
    case HistoricoType.CapturaResponsavelProposta:
      return "#2196F333";
    case HistoricoType.Chat:
    case HistoricoType.Email:
    case HistoricoType.UploadDocumento:
      return "#EAEFFF";
    case HistoricoType.Voltou:
    case HistoricoType.BaixaCheckListCredito:
    case HistoricoType.BaixaCheckListSuporteFinanceiro:
      return "#FBE2CC";
    case HistoricoType.Avancou:
    case HistoricoType.AprovadoConferenciaCheckList:
    case HistoricoType.ComprovantePagamentoAto:
      return "#4CAF5033";
    case HistoricoType.PropostaAssinada:
      return "#4CAF50";
    case HistoricoType.Ajustes:
      return "#ED6C0233";
    default:
      return "gray";
  }
};

export const iconMap: Record<
  HistoricoType,
  { color: string; IconComponent: React.ElementType }
> = {
  [HistoricoType.Email]: {
    color: "#2196F399",
    IconComponent: MdOutlineMailOutline,
  },
  [HistoricoType.Chat]: { color: "#ABBDFF", IconComponent: RiMessage2Fill },
  [HistoricoType.Avancou]: {
    color: "#4CAF5099",
    IconComponent: RiArrowRightFill,
  },
  [HistoricoType.Voltou]: { color: "#F18935", IconComponent: RiArrowLeftFill },
  [HistoricoType.Atualizou]: { color: "#2196F399", IconComponent: MdUpdate },
  [HistoricoType.CompartilharOportunidade]: {
    color: "#2196F399",
    IconComponent: MdUpdate,
  },
  [HistoricoType.CapturaResponsavelProposta]: {
    color: "#2196F399",
    IconComponent: MdUpdate,
  },
  [HistoricoType.ContraPropostaAjuste]: {
    color: "#ED6C0266",
    IconComponent: MdUpdate,
  },
  [HistoricoType.Reprovado]: { color: "#F4363699", IconComponent: MdUpdate },
  [HistoricoType.PropostaCancelada]: {
    color: "#F43636",
    IconComponent: MdCancel,
  },
  [HistoricoType.BaixaCheckListCredito]: {
    color: "#ED6C02",
    IconComponent: IoDocumentAttach,
  },
  [HistoricoType.BaixaCheckListSuporteFinanceiro]: {
    color: "#ED6C02",
    IconComponent: IoDocumentAttach,
  },
  [HistoricoType.AprovadoConferenciaCheckList]: {
    color: "#70BF73",
    IconComponent: IoDocumentAttach,
  },
  [HistoricoType.ComprovantePagamentoAto]: {
    color: "#4CAF5099",
    IconComponent: IoDocumentAttach,
  },
  [HistoricoType.UploadDocumento]: {
    color: "#2196F399",
    IconComponent: MdOutlineFilePresent,
  },
  [HistoricoType.PropostaAssinada]: {
    color: "#FFFFFF",
    IconComponent: RiBallPenFill,
  },
  [HistoricoType.Ajustes]: {
    color: "#ED6C0266",
    IconComponent: RiBallPenFill,
  },
};

export const defaultIcon = {
  color: "gray",
  IconComponent: RxComponentPlaceholder,
};

export const readAttachmentFile = (
  file: File
): Promise<{ base64: string; fileName: string }> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      if (e.target?.result) {
        const base64 = (e.target.result as string).split(",").pop() as string;
        resolve({
          base64,
          fileName: file.name,
        });
      } else {
        reject(new Error("Erro ao ler arquivo"));
      }
    };
    reader.onerror = () => reject(new Error("Erro ao ler arquivo"));
    reader.readAsDataURL(file);
  });
};

export const highlightTitle = (text: string) => {
  const atIndex = text.indexOf("@");

  if (atIndex === -1)
    return (
      <p>
        <strong>{text}</strong>
      </p>
    );

  const beforeAt = text.slice(0, atIndex);
  const afterAt = text.slice(atIndex);

  const spaceIndex = afterAt.indexOf(" ");
  const mention = spaceIndex !== -1 ? afterAt.slice(0, spaceIndex) : afterAt;
  const afterMention = spaceIndex !== -1 ? afterAt.slice(spaceIndex) : "";

  return (
    <p>
      {beforeAt}
      <strong>{mention}</strong>
      {afterMention}
    </p>
  );
};
